/**
 * Lightweight runtime theming helper. Usage:
 * import { applyTheme, AVAILABLE_THEMES } from '../theme';
 * applyTheme('dark');
 */

export const AVAILABLE_THEMES = ['light', 'dark', 'hc'];

export function applyTheme(name) {
  const theme = AVAILABLE_THEMES.includes(name) ? name : 'light';
  const root = document.documentElement;
  root.setAttribute('data-theme', theme === 'light' ? '' : theme);
  // Persist preference (optional)
  try { localStorage.setItem('app-theme', theme); } catch (_) {}
}

export function initTheme() {
  try {
    const stored = localStorage.getItem('app-theme');
    if (stored) applyTheme(stored);
  } catch (_) {}
}

// Auto-init if running in browser context.
if (typeof window !== 'undefined') {
  initTheme();
}
